// extracted by mini-css-extract-plugin
module.exports = {"error_step_container":"transaction-step-collapsible_error_step_container__-__aG","accordion_details":"transaction-step-collapsible_accordion_details__2m280"};